<template>
  <v-container fluid style=" padding:0">
    <div>
      <div id="app ">
        <div style="display:flex; justify-content: space-between;">
          <Breadcrumb class="row justify-content-center mt-4" />
          <span v-if="showLoader">
            <LoaderProgress></LoaderProgress>
          </span>
        </div>
      </div>

      <v-card style="display: flex; flex-wrap: wrap; width: 100%;">
        <!-- <v-row justify="space-between" align="center"> -->
        <!-- <v-col cols="6"> -->
        <div style="display: flex; ">
          <h3 class="h3Style text-blue">Select Role from drop down</h3>
          <!-- </v-col> -->
          <!-- <v-col cols="6"> -->
          <v-select
            class="ml-4 mr-4"
            v-model="select"
            :items="allRoles"
            item-text="role_name"
            item-value="id"
            @change="getRoleFeatures()"
          ></v-select>
        </div>
        <!-- </v-col> -->
        <!-- <v-col cols="12" align="center"> -->
        <v-btn
          class="ml-4 mr-4 mt-4"
          @click="saveUpdates()"
          id="save_button"
          :disabled="disabled == 0"
          color="indigo"
        >
          <span style="color: white;">Save Updates</span>
        </v-btn>
        <!-- </v-col> -->
        <!-- <v-col cols="12" align="center"> -->
        <div v-if="roleStatus === 'Y'">
          <v-dialog v-model="dialogDisable" persistent max-width="600px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ml-4 mr-4 mt-4 icon-white"
                v-bind="attrs"
                v-on="on"
                color="#FE000C"
                style="font-family: Roboto !important;"
              >
                Disable
              </v-btn>
            </template>
            <v-card>
              <v-card-title style="padding: 16px;">
                Are you sure you want to Disable the role?
              </v-card-title>
              <v-spacer></v-spacer>
              <div style="display: flex; justify-content: space-around;">
                <v-btn
                  style="background-color: #FE000C; font-family: Roboto !important;"
                  class="icon-white mb-5"
                  @click="close"
                >
                  Cancel
                </v-btn>
                <v-btn
                  color="primary"
                  style="background-color: #0C479D; font-family: Roboto !important;"
                  @click="activateOrDeactivate('N')"
                >
                  Yes, Disable
                </v-btn>
              </div>
            </v-card>
          </v-dialog>
        </div>

        <div v-if="roleStatus === 'N'">
          <v-dialog v-model="dialogEnable" persistent max-width="600px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ml-4 mr-4 mt-4"
                color="success"
                v-bind="attrs"
                v-on="on"
                id="save_button"
              >
                <span style="color: white;">Enable</span>
              </v-btn>
            </template>
            <v-card>
              <v-card-title style="padding: 16px;">
                Are you sure you want to Enable the role?
              </v-card-title>
              <v-spacer></v-spacer>
              <div style="display: flex; justify-content: space-around;">
                <v-btn
                  style="background-color: #FE000C; font-family: Roboto !important;"
                  class="icon-white mb-5"
                  @click="close"
                >
                  Cancel
                </v-btn>
                <v-btn
                  color="success"
                  style="background-color: #0C479D; font-family: Roboto !important;"
                  @click="activateOrDeactivate('Y')"
                >
                  Yes, Enable
                </v-btn>
              </div>
            </v-card>
          </v-dialog>
        </div>

        <!-- </v-col> -->

        <!-- <v-col cols="12" align="center"> -->
        <v-dialog v-model="dialog" persistent max-width="600px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="indigo"
              v-bind="attrs"
              v-on="on"
              class="mt-4 ml-4 mr-4 mb-4"
            >
              <span style="color:white">Add New Role</span>
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">Create New Role</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      label="Role Name*"
                      v-model="newRoleName"
                      required
                      :rules="usernameRules"
                    ></v-text-field>
                    <small v-if="newRoleName" class="form-text text-muted">
                      <span v-if="rolenameSearchInProgress">searching </span>
                      <v-progress-circular
                        v-if="rolenameSearchInProgress"
                        :size="20"
                        color="amber"
                        indeterminate
                      ></v-progress-circular>

                      <v-icon small color="green" v-if="rolenameAvailable"
                        >mdi-check-circle</v-icon
                      >
                      <span v-if="rolenameAvailable">available</span>

                      <v-icon small color="red" v-if="rolenameNotAvailable"
                        >mdi-minus-circle-off</v-icon
                      >
                      <span v-if="rolenameNotAvailable"
                        >{{ newRoleName }} is not available</span
                      >
                    </small>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-autocomplete
                      :items="allPages"
                      v-model="selectedPages"
                      item-text="display_name"
                      item-value="id"
                      label="Pages Access"
                      multiple
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-container>
              <small>*indicates required field</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">
                Close
              </v-btn>
              <v-btn color="blue darken-1" text @click="saveNewRole">
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Sequence Dialog -->
        <v-dialog
          v-model="showSequenceDialog"
          v-if="roleStatus === 'Y'"
          persistent
          max-width="600px"
        >
          <template v-slot:activator="{ on, attrs }">
            <!-- The button that activates the dialog, it can be hidden if needed -->
            <v-btn
              class="ml-4 mr-4 mb-4 mt-4"
              @click="openSequenceDialog"
              color="indigo"
              v-on="on"
              v-bind="attrs"
            >
              <span style="color: white;">Sequence</span>
            </v-btn>
          </template>
          <!-- The content of the dialog -->
          <v-card>
            <v-card-title class="background-blue"
              ><span style="color :white">Change Sequence?</span></v-card-title
            >
            <div style="display: flex; justify-content: center;">
              <draggable
                @change="changeStatus()"
                v-model="todos"
                style="margin-bottom: 10rem;"
                handle=".handle"
              >
                <transition-group name="list">
                  <div
                    class="todo pt-5 mt-25"
                    v-for="todo in todos"
                    :key="todo"
                  >
                    <v-icon style="cursor: pointer;" class="handle"
                      >mdi-drag</v-icon
                    >
                    <span style="cursor: pointer;" class="handle">{{
                      Object.values(todo)[0]
                    }}</span>
                  </div>
                </transition-group>
              </draggable>
            </div>
            <v-card-actions class="pb-5">
              <v-spacer></v-spacer>
              <v-btn
                rounded
                color="#FE000C"
                @click="showSequenceDialog = false"
              >
                <v-icon left class="icon-white">icon-cancel</v-icon>
                <span style="color: white;">Cancel</span>
              </v-btn>
              <v-btn rounded color="primary" @click="setSequencePage()">
                <v-icon left>icon-availability</v-icon>
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- </v-col> -->
        <!-- </v-row> -->
      </v-card>

      <v-card v-if="!isHidden" class="mx-auto mb-8">
        <div style="display: flex;">
          <v-data-table
            :headers="tableHeaders"
            :items="selectedRolePages"
            :mobile-breakpoint="0"
            :items-per-page="100"
          >
            <template v-slot:item.action="{ item }">
              <v-switch
                color="indigo"
                @change="changeStatus(item, item.status)"
                false-value="N"
                true-value="Y"
                v-model="item.status"
              ></v-switch>
            </template>
          </v-data-table>
          <v-col style="display: flex; height:80%; justify-content: center; ">
            <template>
              <div
                id="container"
                style="box-shadow: none;  display:flex; justify-content:center; flex-direction:column;  width:100% ;"
              >
                <!-- <h4
                  style="background-color: #FE000C; display: flex ; justify-content: center;  padding: 10px; margin-bottom: 20px; border-radius: 3px; font-family: Roboto !important; font-weight: bolder;"
                  class="icon-white pt-3 pb-3 "
                >
                  Sequence
                </h4>
                <draggable
                  @change="changeStatus()"
                  v-model="todos"
                  style="margin-bottom: 10rem;"
                  handle=".handle"
                >
                  <transition-group name="list">
                    <div
                      class="todo pt-5 mt-25"
                      v-for="todo in todos"
                      :key="todo"
                    >
                      <span class="handle">&#8597;</span>
                      <span class="handle">{{ Object.values(todo)[0] }}</span>
                    </div>
                  </transition-group>
                </draggable> -->
              </div>
            </template>
          </v-col>
        </div>
      </v-card>

      <div id="sucessAlert">
        <v-alert outlined type="success" text>
          Data Saved successfully.
        </v-alert>
      </div>
      <div id="errorAlert">
        <v-alert outlined type="warning" prominent border="left">
          Error while saving the data.
        </v-alert>
      </div>
    </div>
  </v-container>
</template>

<script>
import axios from "axios";
import Breadcrumb from "../components/breadcrumbs.vue";
import LoaderProgress from "../components/progressLoader";
import draggable from "vuedraggable";
// import this.$config from "../this.$config";
import router from "../router";
export default {
  name: "customerFeatures",
  components: { Breadcrumb, LoaderProgress, draggable },
  data: () => ({
    showSequenceDialog: false,
    rolenameRules: [
      (v) => !!v || "Rolename is required",
      (v) => (v && !/\s/.test(v)) || "Rolename must not contain any spaces",
    ],
    demo: [],
    tableData: [],
    tableHeaders: [
      { text: "Menu Name", value: "display_name", class: "custom-header" },
      { text: "Enabled", value: "action", class: "custom-header" },
    ],
    usernameRules: [
      (v) => !!v || "Username is required",
      (v) => (v && !/\s/.test(v)) || "Username must not contain any spaces",
    ],
    items: [
      {
        text: "Home",
        disabled: false,
        href: "/",
      },
      {
        text: "Admin Menu",
        disabled: true,
      },

      {
        text: "Role Management",
        disabled: true,
      },
    ],
    todos: [],
    new_list: [],
    IDPage: [],
    idOfPageSequence: [],
    showLoader: false,
    select: "",
    roleStatus: "",
    dialog: false,
    dialogDisable: false,
    dialogEnable: false,
    editDialog: false,
    roleSelected: {},
    allRoles: [],
    allPages: [],
    selectedPages: [],
    newRoleName: "",
    selectedRolePages: [],
    disabled: 0,
    editDisabled: 1,
    isHidden: true,
    id: "",
    rolenameSearchInProgress: false,
    rolenameAvailable: false,
    rolenameNotAvailable: false,
  }),
  watch: {
    newRoleName: function(val) {
      if (val) {
        if (!this.rolenameSearchInProgress) {
          setTimeout(() => {
            this.searchRoleName();
          }, 2000);
        }
        this.rolenameSearchInProgress = true;
        this.rolenameAvailable = false;
        this.rolenameNotAvailable = false;
      }
    },
  },
  methods: {
    openSequenceDialog() {
      this.showSequenceDialog = true;
    },

    searchRoleName() {
      console.log("searchUserName  --> ");

      let req = {
        role_name: this.newRoleName,
      };
      this.rolenameSearchInProgress = true;
      this.rolenameAvailable = false;
      this.rolenameNotAvailable = false;
      let config = {
        method: "post",
        url: `${this.$config.backend_url}/RoleNameValidation`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
        data: req,
      };
      this.showLoader = true;

      this.noteLastAPICallTime();
      axios(config)
        .then((response) => {
          this.showLoader = false;

          this.rolenameSearchInProgress = false;
          if (response.data.valid === true) {
            this.rolenameAvailable = true;
            this.rolenameNotAvailable = false;
          } else if (response.data.valid === false) {
            this.rolenameNotAvailable = true;
            this.rolenameAvailable = false;
          }
        })
        .catch((error) => {
          this.showLoader = false;

          alert("internal error", error);
          this.rolenameSearchInProgress = false;
        });
    },
    getRoleFeatures() {
      this.disabled = 0;
      this.editDisabled = 0;

      console.log(">>>> getRoleFeatures with : ", this.select);
      let role = this.allRoles.filter((role) => role.id === this.select)[0];
      this.roleStatus = role.active;
      this.roleSelected = role;
      let pages = this.allPages;
      let pagesofThisRole = [];
      pages.forEach((page) => {
        let pageObj = {};
        pageObj["id"] = page.id;
        pageObj["display_name"] = page.display_name;
        pageObj["group_id"] = page.group_id;
        pageObj["status"] = role.pages.includes(page.id) ? "Y" : "N";
        pagesofThisRole.push(pageObj);
      });
      this.selectedRolePages = pagesofThisRole;
      console.log("this.selectedRolePages", this.selectedRolePages);
      for (let i = 0; i < this.selectedRolePages.length; i++) {
        if (
          (this.selectedRolePages[i]["status"] == "Y" &&
            this.selectedRolePages[i]["group_id"] == 0) ||
          this.selectedRolePages[i]["group_id"] == null
        ) {
          this.new_list.push(this.selectedRolePages[i]["display_name"]);
          this.IDPage.push(this.selectedRolePages[i]["id"]);
        }
      }
      for (let i = 0; i < this.new_list.length; i++) {
        let x = {};
        x[this.IDPage[i]] = this.new_list[i];
        this.demo.push(x);
      }
      Object.entries(this.todos).forEach(([key, value]) => {
        console.log("K V:", key, value);
      });
      console.log("checking select Roles", this.new_list);
      this.idOfPageSequence = this.IDPage;
      this.IDPage = [];
      this.todos = this.demo;
      this.demo = [];
      this.new_list = [];
      this.isHidden = false;
    },
    saveUpdates() {
      console.log(
        ">>>> saveUpdates with : ",
        this.select,
        this.selectedRolePages
      );
      let req = {
        role_id: this.select,
        updated_by: sessionStorage.getItem("jwt"),
        application_feature_id: this.selectedRolePages
          .filter((page) => page.status === "Y")
          .map((page) => page.id),
      };

      this.showLoader = true;
      let config = {
        method: "post",
        url: `${this.$config.backend_url}/updateRolePagesData`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
        data: req,
      };
      this.noteLastAPICallTime();
      axios(config)
        .then((response) => {
          this.showLoader = false;
          if (response.data.status == "S") {
            document.querySelector("#sucessAlert").style.display = "block";
            this.getAllRoles();
            this.setSequencePage();
            this.getAllPages();
          }
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else {
            document.querySelector("#errorAlert").style.display = "block";
            console.log("axios error", error.message);
          }
        });

      this.close();
      this.disabled = 0;
    },
    setSequencePage() {
      let dict = [];
      dict.push(this.todos);
      dict.push(this.select);
      let config = {
        method: "post",
        url: `${this.$config.backend_url}/SequencePage`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
        data: dict,
      };
      axios(config).then((response) => {
        this.showLoader = false;

        if (response.data.status == "S") {
          document.querySelector("#sucessAlert").style.display = "block";
          this.showSequenceDialog = false;
        }
      });
    },
    activateOrDeactivate(status) {
      let req = {
        role_id: this.select,
        active: status,
        updated_by: sessionStorage.getItem("jwt"),
      };
      this.showLoader = true;
      let config = {
        method: "post",
        url: `${this.$config.backend_url}/updateRolePagesData`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
        data: req,
      };
      this.noteLastAPICallTime();
      axios(config)
        .then((response) => {
          this.showLoader = false;
          if (response.data.status == "S") {
            document.querySelector("#sucessAlert").style.display = "block";
            this.getAllRoles();
            this.getRoleFeatures();
            this.roleStatus = status;
          }
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else {
            document.querySelector("#errorAlert").style.display = "block";
            console.log("axios error", error.message);
          }
        });
      this.close();
    },
    changeStatus(item, status) {
      this.disabled = 1;
      console.log("item while changeing data", status, item);
      if (status == "Y") {
        item.status = "Y";
      } else if (status == "N") {
        item.status = "N";
      }
      console.log("item AFTER changeing data", item.status);
      this.todos = [];
      for (let i = 0; i < this.selectedRolePages.length; i++) {
        if (
          (this.selectedRolePages[i]["status"] == "Y" &&
            this.selectedRolePages[i]["group_id"] == 0) ||
          this.selectedRolePages[i]["group_id"] == null
        ) {
          console.log("Printing yyes", this.selectedRolePages[i]);
          this.new_list.push(this.selectedRolePages[i]["display_name"]);
          this.IDPage.push(this.selectedRolePages[i]["id"]);
        }
      }
      for (let i = 0; i < this.new_list.length; i++) {
        let x = {};
        x[this.IDPage[i]] = this.new_list[i];
        this.demo.push(x);
        //console.log("keys:",Object.keys(x));
      }
      Object.entries(this.todos).forEach(([key, value]) => {
        console.log("K V:", key, value);
      });
      console.log("checking select Roles", this.new_list);
      //console.log("checking list after changing status:",this.todos);
      this.idOfPageSequence = this.IDPage;
      this.IDPage = [];
      this.todos = this.demo;
      this.demo = [];
      this.new_list = [];
    },
    close() {
      this.dialog = false;
      this.dialogDisable = false;
      this.dialogEnable = false;
      this.selectedPages = [];
      this.newRoleName = "";
    },
    closeEdit() {
      this.editDialog = false;
    },
    saveNewRole() {
      if (!this.newRoleName || !this.newRoleName.trim()) {
        alert("'Role Name' is required");
        return;
      }
      const req = {
        role_name: this.newRoleName,
        application_feature_id: this.selectedPages,
        active: "Y",
        created_by: sessionStorage.getItem("jwt"),
      };
      console.log("req is", req);

      this.showLoader = true;
      let config = {
        method: "post",
        url: `${this.$config.backend_url}/createRole`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
        data: req,
      };
      this.noteLastAPICallTime();

      axios(config)
        .then((response) => {
          this.showLoader = false;

          if (response.data.status == "S") {
            document.querySelector("#sucessAlert").style.display = "block";
            this.getAllRoles();
          }
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else {
            document.querySelector("#errorAlert").style.display = "block";
            console.log("axios error", error.message);
          }
        });
      this.close();
    },
    getAllRoles() {
      this.showLoader = true;
      let config = {
        method: "get",
        url: `${this.$config.backend_url}/getRoles`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      };
      this.noteLastAPICallTime();

      axios(config)
        .then((response) => {
          this.showLoader = false;
          console.log("typeof response.data", typeof response.data);
          console.log("typeof response.data.data", typeof response.data.data);
          if (response.data.data) {
            this.allRoles = response.data.data;
            if (this.allRoles.length == 1) {
              this.id = this.allRoles[0].id;
              this.select = this.id;
            }
          } else {
            this.allRoles = [];
          }
          console.log("checking roles", this.allRoles);
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else {
            alert("internal error");
            console.log("axios error", error.message);
          }
        });
    },
    getAllPages() {
      this.showLoader = true;
      let config = {
        method: "get",
        url: `${this.$config.backend_url}/getPages`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      };
      this.noteLastAPICallTime();

      axios(config)
        .then((response) => {
          this.showLoader = false;
          if (response.data.data) {
            this.allPages = response.data.data;
            if (this.allRoles.length == 1) {
              this.getRoleFeatures();
            }
          } else {
            this.allPages = [];
          }
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else {
            alert("internal error");
            console.log("axios error", error.message);
          }
        });
    },
  },

  beforeMount() {
    this.getAllRoles();

    this.getAllPages();
  },
};
</script>
<style scoped>
.h2Style {
  color: #000000;
  padding: 12px;
}

.h3Style {
  font-size: 16px;

  margin-left: 30px;
  margin-top: 20px;
}

.h4Style {
  /* color: #0400fe; */
  margin-left: 0px;
  margin-top: 0px;
  font-size: 20px;
}

#container {
  max-width: 250px;
  padding: 5px;
  border-radius: 5px;
  border-color: red;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.3);
}

.todo {
  max-width: 320px;
  padding: 5px;
  border-radius: 5px;
  margin-bottom: 20px;
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.1);
}

#loaderStyle {
  display: none;
}

#warningAlert {
  display: none;
}

#sucessAlert {
  display: none;
}

#errorAlert {
  display: none;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

@media screen and (min-width: 600px) {
  #div2 {
    display: none;
  }
}

/* On screens that are 600px wide or less, the background color is olive */
@media screen and (max-width: 600px) {
  #div1 {
    display: none;
  }

  .list-move {
    transition: 0.5s;
  }
}
</style>
